import React, {PureComponent} from "react"
import styled from "styled-components"

import {Hr, Row, Col} from "@irati/ui/src/Layout"
import {FormattedMessage, FormattedCurrency, InjectIntl} from "@irati/utils/lang"
import {Body} from "@irati/ui/src/Typography"
import mainTheme from "@irati/ui/src/global/theme"

const RowPadding = styled(({padSubtotal, ...rest}) => <Row {...rest} />)`
  ${({padSubtotal, theme}) => (padSubtotal ? `padding-bottom: ${theme.spacing.one};` : null)}
`

interface Props extends InjectIntl {
  subtotal: string | number | null
  discount: string | number
  walletBalanceToUse: string | number
  currency: string | null
  padSubtotal: boolean
  isCents: boolean
}

export default class Subtotal extends PureComponent<Props> {
  static defaultProps = {
    padSubtotal: false,
    walletBalanceToUse: 0,
    isCents: true
  }

  render() {
    const {subtotal, discount, padSubtotal, walletBalanceToUse, currency, isCents} = this.props

    return (
      <div className="orderSummarySubtotal">
        <Row>
          <Col xs={12}>
            {discount > 0 && (
              <Row>
                <Col xs={7}>
                  <Body small>
                    <FormattedMessage id="perks.components.orderSummary.subtotal.discount" />
                  </Body>
                </Col>
                <Col xs={5}>
                  <div className="pull-right">
                    <Body small color={mainTheme.colors.utility.error}>
                      - <FormattedCurrency isCents={isCents} currency={currency} value={discount} />
                    </Body>
                  </div>
                </Col>
              </Row>
            )}
            <RowPadding padSubtotal={padSubtotal && discount > 0}>
              <Col xs={8}>
                <Body small>
                  <FormattedMessage id="perks.components.orderSummary.subtotal.subtotal" />
                </Body>
              </Col>
              <Col xs={4}>
                <div className="pull-right">
                  <Body small>
                    <FormattedCurrency isCents={isCents} currency={currency} value={subtotal} />
                  </Body>
                </div>
              </Col>
            </RowPadding>
            {walletBalanceToUse > 0 && (
              <Row>
                <Col xs={8}>
                  <FormattedMessage id="perks.components.orderSummary.subtotal.perkboxWallet" />
                </Col>
                <Col xs={4}>
                  <div className="pull-right">
                    <Body small>
                      - <FormattedCurrency isCents={isCents} currency={currency} value={walletBalanceToUse} />
                    </Body>
                  </div>
                </Col>
              </Row>
            )}
            <Hr />
          </Col>
        </Row>
      </div>
    )
  }
}
